import React, { useEffect, useState, useCallback } from "react";
import { useTranslation } from "next-i18next";
import Image from "next/image";

const Banner = () => {
  const { t } = useTranslation("landingPage");
  const [innerWidth, setInnerWidth] = useState(0);
  useEffect(() => {
    setInnerWidth(window.innerWidth);
    window.addEventListener("resize", () => {
      setInnerWidth(window.innerWidth);
    });
  }, []);
  return (
    <div className="main-banner">
      {(innerWidth !== 0 && innerWidth <= 650) && (
        <div className="img-mb-banner">
          <Image
            src="/images/common/bg_mb.png"
            alt="background"
            width={390}
            height={403}
            priority={true}
          />
        </div>
      )}
      <div className="container main-banner-cont">
        <div className="banner">
          {innerWidth > 650 && (
            <div className="img-banner">
              <Image
                src="/images/landingPage/background-banner-lg-v2.png"
                alt="background"
                width={1296}
                height={647}
                priority={true}
              />
            </div>
          )}

          <h1 dangerouslySetInnerHTML={{ __html: t("slogan") }} />
          <div className="sub-slogan">
            {t("sub_slogan")}
            {/* <br />⭐ {t('OUR_BEST_SELLER')} ⭐ */}
          </div>
          <div className="btn btn-order-now">
            <a href="#sim-order">{t("Order_Now")}</a>
          </div>
          {/* <div className="info-call-list">
            <div className="info-call">
              <div className="call-head">60’</div>
              <div>{t('Local_Calls')}</div>
            </div>
            <div className="info-call">
              <div className="call-head">100</div>
              <div>{t('Local_SMS')}</div>
            </div>
            <div className="info-call">
              <div className="call-head">30’</div>
              <div>{t('International_Calls')}</div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Banner;
